import PropTypes from 'prop-types';
import React from 'react';
import {
	FormattedMessage,
	defineMessages,
	injectIntl,
} from 'react-intl';

import AvailabilityList, {
	AvailabilityLabelStatus,
	AvailabilityListSize,
} from '~/components/patterns/statuses/AvailabilityList';
import BenefitLabel from './BenefitLabel';
import ExternalLink from '~/components/patterns/links/ExternalLink';

import {
	BENEFIT_ISSUES_CONFIGURATION,
	BENEFIT_REPORTING_API,
} from '~/model/benefits';



const messages = defineMessages({
	hints: {
		[BENEFIT_ISSUES_CONFIGURATION]: {
			content: {
				id: 'ui.pricing.agency.benefitTooltips.issuesConfiguration.content',
			},
			href: {
				id: 'ui.pricing.agency.benefitTooltips.issuesConfiguration.href',
			},
			link: {
				id: 'ui.pricing.agency.benefitTooltips.issuesConfiguration.link',
			},
		},
		[BENEFIT_REPORTING_API]: {
			content: {
				id: 'ui.pricing.agency.benefitTooltips.reportingAPI.content',
			},
			href: {
				id: 'ui.pricing.agency.benefitTooltips.reportingAPI.href',
			},
			link: {
				id: 'ui.pricing.agency.benefitTooltips.reportingAPI.link',
			},
		},
	},
});



const PlanFeaturesList = (props) => {
	const {
		benefits,
		compact,
		intl,
		lostBenefits,
	} = props;

	const items = benefits.filter((benefit) => {
		if (compact && !benefit.detailed) {
			return true;
		}

		if (!compact && benefit.detailed) {
			return true;
		}

		if (benefit.detailed === undefined) {
			return true;
		}

		return false;
	}).map((benefit) => {
		const helpHintProperties = messages.hints[benefit.name] && messages.hints[benefit.name].link ? {
			text__link: (
				<ExternalLink href={intl.formatMessage(messages.hints[benefit.name].href)}>
					<FormattedMessage {...messages.hints[benefit.name].link} />
				</ExternalLink>
			),
		} : {};

		return {
			hint: messages.hints[benefit.name] && (
				<FormattedMessage
					{...messages.hints[benefit.name].content}
					values={helpHintProperties}
				/>
			),
			label: (
				<BenefitLabel
					disabled={!!benefit.disabled}
					name={benefit.name}
				/>
			),
			status: benefit.disabled
				? (lostBenefits.indexOf(benefit.name) !== -1 ? AvailabilityLabelStatus.Warning : AvailabilityLabelStatus.Unavailable)
				: AvailabilityLabelStatus.Available,
		};
	});

	return (
		<AvailabilityList
			items={items}
			size={AvailabilityListSize.XSmall}
		/>
	);
};



PlanFeaturesList.defaultProps = {
	compact: false,
};

PlanFeaturesList.propTypes = {
	benefits: PropTypes.arrayOf(
		PropTypes.shape({
			detailed: PropTypes.bool,
			disabled: PropTypes.bool,
			name: PropTypes.string.isRequired,
		}),
	).isRequired,
	compact: PropTypes.bool,
	lostBenefits: PropTypes.array.isRequired,
};



export default injectIntl(PlanFeaturesList);
